<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xv">EARTH AS IT IS</a></p><a id="page_xv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Fm03.vue?fa08c7e4